import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { ClassificationExampleEdit } from '../ClassificationExampleEdit';

export const Route = createFileRoute('/admin-console/platform-content/ai-training/classification-example/create')({
    staticData: {
        breadcrumb: { title: 'Create' },
        ui: { title: 'Create classification example' },
        presentation: 'overlay',
    },
    component: CreateClassificationExample,
});

function CreateClassificationExample() {
    return (
        <PageController route={Route}>
            <ClassificationExampleEdit mode="create" />
        </PageController>
    );
}
